import { module } from 'angular';
import headersBuilderDirective from './headers-builder/headers-builder.directive';
import jsonInputDirective from './json-input/json-input.directive';
import kformBuilderComponent from './kform-builder.component';
import kformBuilderCommonOptionsConstant from './common-options.constant';
import kformBuilderConditionalDirective	from './conditional/kform-builder-conditional.directive';
import kformBuilderFormOptionsConstant from './kform-builder-form-options.constant';
import kformBuilderComponentDirective from './component/kform-builder-component.directive';
import kformBuilderEditButtonsComponent from './edit-buttons/kform-builder-edit-buttons.component';
import kformBuilderListComponent from './list/kform-builder-list.component';
import kformBuilderElementComponent from './element/kform-builder-element.component';
import kformBuilderOptionCustomValidationDirective
	from './option/custom-validation/kform-builder-option-custom-validation.directive';
import kformBuilderOptionDirective from './option/kform-builder-option.directive';
import kformBuilderOptionInputFormatDirective
	from './option/input-format/kform-builder-option-input-format.directive';
import kformBuilderOptionInputsLabelPositionDirective
	from './option/inputs-label-position/kform-builder-option-inputs-label-position.directive';
import kformBuilderOptionKeyDirective	from './option/key/kform-builder-option-key.directive';
import kformBuilderOptionLabelPositionDirective
	from './option/label-position/kform-builder-option-label-position.directive';
import kformBuilderOptionOptionsLabelPositionDirective
	from './option/options-label-position/kform-builder-option-options-label-position.directive';
import kformBuilderOptionPathDirective	from './option/path/kform-builder-option-path.directive';
import kformBuilderOptionShortcutDirective
	from './option/shortcut/kform-builder-option-shortcut.directive';
import kformBuilderToolbarComponent from './toolbar/kform-builder-toolbar.component';
import kformBuilderTooltipDirective	from './tooltip/kform-builder-tooltip.directive';
import labelValidatorDirective from './label-validator/label-validator.directive';
import multiMaskInputDirective from './multi-mask-input/multi-mask-input.directive';
import nodesValueBuilderDirective from './nodes-value-builder/nodes-value-builder.directive';
import objectBuilderDirective from './object-builder/object-builder.directive';
import valueBuilderDirective from './value-builder/value-builder.directive';
import valueBuilderWithShortcutsDirective
	from './value-builder-with-shortcuts/value-builder-with-shortcuts.directive';

import './kform-builder.scss';
import KformBuilderListController from './list/kform-builder-list.controller';


export default module('app')
	.component('kformBuilder', kformBuilderComponent)
	.constant('COMMON_OPTIONS', kformBuilderCommonOptionsConstant)
	.constant('FORM_OPTIONS', kformBuilderFormOptionsConstant)
	.directive('headersBuilder', headersBuilderDirective)
	.directive('jsonInput', jsonInputDirective)
	.controller('KformBuilderListController', KformBuilderListController)
	.directive('kformBuilderComponent', kformBuilderComponentDirective)
	.directive('kformBuilderConditional', kformBuilderConditionalDirective)
	.component('kformBuilderEditButtons', kformBuilderEditButtonsComponent)
	.component('kformBuilderElement', kformBuilderElementComponent)
	.component('kformBuilderList', kformBuilderListComponent)
	.directive('kformBuilderOption', kformBuilderOptionDirective)
	.directive('kformBuilderOptionInputFormat', kformBuilderOptionInputFormatDirective)
	.directive('kformBuilderOptionInputsLabelPosition', kformBuilderOptionInputsLabelPositionDirective)
	.directive('kformBuilderOptionKey', kformBuilderOptionKeyDirective)
	.directive('kformBuilderOptionLabelPosition', kformBuilderOptionLabelPositionDirective)
	.directive('kformBuilderOptionOptionsLabelPosition', kformBuilderOptionOptionsLabelPositionDirective)
	.directive('kformBuilderOptionPath', kformBuilderOptionPathDirective)
	.directive('kformBuilderOptionShortcut', kformBuilderOptionShortcutDirective)
	.directive('kformBuilderOptionCustomValidation', kformBuilderOptionCustomValidationDirective)
	.component('kformBuilderToolbar', kformBuilderToolbarComponent)
	.directive('kformBuilderTooltip', kformBuilderTooltipDirective)
	.directive('labelValidator', labelValidatorDirective)
	.directive('multiMaskInput', multiMaskInputDirective)
	.directive('nodesValueBuilder', nodesValueBuilderDirective)
	.directive('objectBuilder', objectBuilderDirective)
	.directive('valueBuilder', valueBuilderDirective)
	.directive('valueBuilderWithShortcuts', valueBuilderWithShortcutsDirective)
	.name;
